// LOGIN DIALOG
import PSRegistration from './login/register_dialog.js';

// HELP DIALOGS
import LeaveAutoLinkHelp from './help/leave_auto_link_help.js';
import BursariesHelp from './help/bursaries_help.js';
import DocumentsHelp from './help/documents_help.js';
import EducationHelp from './help/education_help.js';
import EmployeeDetailsHelp from './help/employee_details_help.js';
import EmployeeListingHelp from './help/employment_listing_help.js';
import LeaveAdjustementsHelp from './help/leave_adjustments_help.js';
import LeaveEarnedHelp from './help/leave_earned_help.js';
import LeaveSummaryHelp from './help/leave_summary_help.js';
import LeaveTakenHelp from './help/leave_taken_help.js';
import ManagedDepartmentsHelp from './help/managed_departments_help.js';
import ManagedEmployeesHelp from './help/managed_employees_help.js';
import ManagersHelp from './help/managers_help.js';
import BackupManagersHelp from './help/backup_managers_help.js';
import NotesHelp from './help/notes_help.js';
import LeaveManagementHelp from './help/approve_leave_help.js';
import CompaniesHelp from './help/companies_help.js';
import DepartmentsHelp from './help/departments_help.js';
import EventsHelp from './help/events_help.js';
import EmployeeFieldsHelp from './help/employee_fields_help.js';
import LeaveTypesHelp from './help/leave_types_help.js';
import HolidaysHelp from './help/holidays_help.js';
import SystemNotificationsHelp from './help/system_notifications_help.js';
import SurveySetupHelp from './help/surveys_setup_help.js';
import EmployeeGroupsHelp from './help/employee_groups_help.js';
import LeaveCancelHelp from './help/cancel_leave_help.js';
import ApproveUsersHelp from './help/approve_users_help.js';
import PromoteDemoteHelp from './help/promote_demote_help.js';
import FeatureRolesHelp from './help/feature_roles_help.js';
import EmployeeImportHelp from './help/employee_import_help.js';
import TimeImportHelp from './help/time_attendance/import_time_log_help.js';
import MobileConfigurationHelp from './help/mobile_configuration_help.js'; 
import RequisitionConfigurationHelp from './help/requisition_configuration_help.js'; 
import BranchesHelp from './help/branches_help.js';
import LeaveRestrictionRuleHelp from './help/leave_restriction_rules.js';
import UpcomingBirthdaysHelp from './help/upcoming_birthdays_help.js';
import LeaveCategoriesHelp from './help/leave_categories_help.js';
import ContractsHelp from './help/contracts_help.js';
import EmployeeDocumentsHelp from './help/employee_documents_help.js';
import GeneralDocumentsHelp from './help/general_documents_help.js';
import SkillsCompetencyHelp from './help/skills_competency_help.js';
//import AddLeaveGeneralHelp from './help/add_leave_general_help.js';
//import AddLeaveHolidayHelp from './help/add_leave_holiday_help.js';
//import AddLeaveRestrictionHelp from './help/add_leave_restriction_help.js';
//import AddLeaveRolesHelp from './help/add_leave_roles_help.js';
import TimeViewHelp from './help/time_view_help.js';
import ReportTimeLoggedHelp from './help/report_time_logged_help.js';
import ApproveTimeHelp from './help/approve_time_logged_help.js';
import ApprovalStructureHelp from './help/time_management_setup_help.js';
import EmployeeHistoryLogHelp from './help/employee_history_help.js';

// Performance management help
import EditPerformanceManagementHelp from './help/performance_management/add_edit_perf_manage_help.js';
import PerformanceObjectiveDetailsHelp from './help/performance_management/objective_details_help.js';
import PerformanceObjectivesSummaryHelp from './help/performance_management/objectives_summary_help.js';
import PerformanceCyclesHelp from './help/performance_management/cycle_setup_help.js';
import CompanyGoalsHelp from './help/performance_management/company_goals_help.js';
import ObjectiveMeasuresHelp from './help/performance_management/objective_measures_help.js';
import CycleStageHelp from './help/performance_management/cycle_stage_help.js';
import RatingMethodsHelp from './help/performance_management/rating_methods_help.js';
import SetLinkPerfCyclesHelp from './help/performance_management/set_link_perf_cycles_help.js'
import SetObjectivesMeasuresHelp from './help/performance_management/set_objectives_measures_help.js'
import PerformanceProgressReportHelp from './help/performance_management/performance_progress_report_help.js'
import SelfReviewRatingHelp from './help/performance_management/self_review_rating_help.js'
import PeerReviewRatingHelp from './help/performance_management/peer_review_rating_help.js'
import ManagerReviewRatingHelp from './help/performance_management/management_review_rating_help.js'

//Report help
import EmployeeDocumentCountReportHelp from './help/reports_help/employee_document_count_report_help.js'; 
import EmployeeEmploymentListingReportHelp from './help/reports_help/employee_employment_listing_report_help.js'; 
import OutstandingDataHelp from './help/reports_help/outstanding_data_help.js';
import SkillsCompetencyDataHelp from './help/reports_help/skill_competency_data_help.js';
import EmployeesCurrentlyOnLeaveHelp from './help/reports_help/employees_currently_on_leave_help.js';
import EmployeesActivePerDepartmentCountHelp from './help/reports_help/employees_active_per_department_count_help.js';
import EmployeesWithRolesHelp from './help/reports_help/employees_with_roles_help.js';
import EmployeeLeaveComingUpHelp from './help/reports_help/employee_leave_coming_up_help.js';
import DepartmentGrowthReportHelp from './help/reports_help/department_growth_report_help.js';
import DiversityStatisticsReportHelp from './help/reports_help/diversity_statistics_report_help.js';
import ManagerSubordinateStructureHelp from './help/reports_help/manager_subordinate_structure_help.js';
import BackupManagerReportHelp from './help/reports_help/backup_manager_report_help.js';
import LeaveAvailableHelp from './help/reports_help/available_leave_help.js';
import LeaveTakenReportHelp from './help/reports_help/leave_taken_report_help.js';
import LeaveTakenBreakdownByLeaveEntryHelp from './help/reports_help/leave_taken_breakdown_by_leave_entry_help.js';
import LeaveCostPerDepartmentHelp from './help/reports_help/leave_cost_per_department_help.js';
import EmployeesTakingLeavePerDepartmentCountHelp from './help/reports_help/employees_taking_leave_per_department_count_help.js';
import LeaveTakenComparisonBetweenDepartmentsHelp from './help/reports_help/leave_taken_comparison_between_departments_help.js';
import LeaveTakenPerDayCountHelp from './help/reports_help/leave_taken_per_day_count_help.js';
import LeaveAvailableByCompanyHelp from './help/reports_help/leave_available_by_company_help.js';
import SickLeaveCyclesInformationHelp from './help/reports_help/sick_leave_cycles_information_help.js';
import LeaveTrendsHelp from './help/reports_help/leave_trends_help.js';
import SurveyResultsHelp from './help/reports_help/survey_results_help.js';
import LeaveTakenByLeaveTypeHelp from './help/reports_help/leave_taken_by_leave_type_help.js';
import EmployeeAttendanceInformationHelp from './help/reports_help/employee_attendance_information_help.js';
import SetupTimeRulesHelp from './help/setup_time_rules_help.js';
import AttendanceDepartmentHelp from './help/reports_help/attendance_report_per_department_help.js';
import AttendanceEmployeeReportHelp from './help/reports_help/attendance_report_per_employee_help.js';
import EmployeeFieldReportHelp from './help/reports_help/employee_field_report_help.js';
import EEAReportHelp from './help/reports_help/eea_report_help.js';
import Habit5ReportHelp from './help/reports_help/habit_5_report_help.js'

import PerformanceCycleRatingsHelp from './help/performance_management/performance_cycle_ratings_help.js';
import RatingsDistributionHelp from './help/performance_management/rating_distribution_helps.js'

import SetupOvertimeRulesHelp from './help/setup_overtime_rules_help.js'
import CheckAttendanceReportHelp from './help/check_attendance_report_help.js';


// ADMIN DIALOGS
import AdminAddNewHolidayType from './admin/add_new_holiday_type.js';
import EmployeeCategoryAddPage from './admin/employee_category_add.js';
import EmployeeDocumentReject from './admin/employee_document_reject.js';
import EmployeeGroupsAdd from './admin/employee_groups_add.js';
import AdminImportEmployees from './admin/import_employees.js';
import AdminImportHoliday from './admin/import_holiday.js';
import MobileConfigurationAddImage from './admin/mobile_configuration_add_image.js';
import RequisitionConfigurationAddImage from './admin/requisition_configuration_add_image.js';
import RejectUsers from './admin/reject_users.js';
import SurveySetupAdd from './admin/surveys_setup_add.js';
import SurveySetupQuestionsAdd from './admin/surveys_setup_questions_add.js';
import SystemNotificationsAdd from './admin/system_notifications_add.js';
import UploadGeneralDocument from './admin/upload_general_document.js';
import EditDocument from './admin/edit_document.js';
import LeaveRestrictionRule from './admin/leave_restriction_rule.js';
import LeaveRestrictionRuleLeaveTypeEdit from './admin/leave_restriction_rule_leave_type_edit.js';
import AdminImportTime from './admin/import_time_logged.js';

// EMPLOYEE DIALOGS
import EmployeeAddField from './employee/employee_add_field.js';
import EmployeeAddLinkedLeave from './employee/employee_add_linked_leave.js';
import EmployeeAddManagerDepartment from './employee/employee_add_manager_department.js';
import EmployeeConvertLeaveType from './employee/employee_convert_linked_leave_type.js';
import EmployeeEndLeaveType from './employee/employee_end_linked_leave.js';
import EmployeeLeaveEntry from './employee/employee_leave_entry.js';
import EmployeeResign from './employee/employee_resign.js';
import EmployeeUploadDocument from './employee/employee_upload_document.js';
import EmployeeUploadLeaveDocument from './employee/employee_upload_leave_document.js';
import EmployeeUploadPhoto from './employee/employee_upload_photo.js';
import InsertLeaveEntry from './employee/insert_leave_entry.js';
import EmployeeAddLinkedLeaveByCategory from './employee/employee_add_linked_leave_by_category.js';
import EmployeeAddDisciplinary from './employee/employee_add_disciplinary.js';
import EmployeeUploadPayrollDocument from './employee/employee_upload_payroll_document.js'
// PERFORMANCE MANAGEMENT
import ViewPerfObjectivePlan from './performance_management/view_perf_objective_plan.js';
import CreateCycle from './performance_management/create_cycle.js';
import AddObjectivePlan from './performance_management/add_objective_plan.js';
import AddRatingMethod from './performance_management/add_rating_method.js';
import AddToObjectivePlan from './performance_management/add_objective_to_plan.js';
import AddCycleStep from './performance_management/add_cycle_step.js';
import AddCompanyObj from './performance_management/add_company_obj.js';
import LinkCompanyObjectives from './performance_management/linked_company_objective.js';
import AddPeerGroup from './performance_management/add_peer_group_and_member.js';
import RatingAndFeedback from './performance_management/rating_And_feedback.js';
import AddPeerMembersObjePlan from './performance_management/add_peer_members_to_objective_plan.js'

// MANAGER DIALOGS
import LeaveReject from './manager/leave_reject.js';
import LeaveCancellationReject from './manager/leave_cancellation_reject.js';

// NOTIFICATION DIALOGS
import OpenNotification from './notifications/open_notification_dialog.js';

// WIZARD DIALOGS
import WizardCompaniesEntry from './wizard/wizard_companies.js';
import WizardDepartmentsEntry from './wizard/wizard_departments.js';
import WizardEmployeeFieldsEntry from './wizard/wizard_employee_fields.js';
import WizardHolidayEntry from './wizard/wizard_holidays.js';
import WizardLeaveTypesEntry from './wizard/wizard_leave_types.js';
import WizardFinish from './wizard/wizard_finish.js';
import WizardFinishBasic from './wizard/wizard_finish_basic.js';

// REPORT DIALOGS
import ReportCompanyLeaveAvailableAdjustDate from './reports/report_company_leave_available_adjust_and_refresh.js';
import ReportLeaveTakenSettings from './reports/report_leave_taken_settings.js';

// LEAVE SETUP DIALOGS
import WizardLeaveSetupDescription from './leave_setup/wizard_leave_setup_description.js';
import WizardLeaveSetupRoles from './leave_setup/wizard_leave_setup_roles.js';
import WizardLeaveSetupHolidays from './leave_setup/wizard_leave_setup_holidays.js';
import WizardHolidaySetup from './leave_setup/wizard_holiday_setup.js';
import WizardLeaveSetupCycle from './leave_setup/wizard_leave_setup_cycle.js';
import WizardLeaveSetupRestrictions from './leave_setup/wizard_leave_setup_restrictions.js';
import WizardLeaveSetupEmployees from './leave_setup/wizard_leave_setup_employees.js';
import WizardLeaveSetupOverview from './leave_setup/wizard_leave_setup_overview.js';

//TIME MANAGEMENT
import LogTime from './time_management/log_time.js';
import EditProject from './time_management/edit_project.js';
import TimeLoggedReject from './time_management/time_logged_reject.js';
import AddApprovalStructure from './time_management/add_approval_structure.js';
import EditTransactionType from './payroll_integration/edit_transaction_type.js'; 
import LogTimeEmployee from './time_management/log_time_employee.js'
import AddTimeRules from './time_management/add_time_rules.js';
import OvertimeRules from './time_management/add_overtime_rules.js';

// ANONYMOUS SURVEY SEGMENTS
import EditSurveySegmentsPage from './admin/survey_segments/survey_segments.js';
import AnonymousSurveySetupHelp from './help/anonymous_surveys/anonymous_survey_setup_help.js';

export default [
	PSRegistration,

	BursariesHelp,
	DocumentsHelp,
	EducationHelp,
	EmployeeDetailsHelp,
	EmployeeListingHelp,
	LeaveAdjustementsHelp,
	LeaveEarnedHelp,
	LeaveSummaryHelp,
	LeaveTakenHelp,
	BackupManagersHelp,
	ManagedDepartmentsHelp,
	ManagedEmployeesHelp,
	ManagersHelp,
	NotesHelp,
	LeaveManagementHelp,
	CompaniesHelp,
	DepartmentsHelp,
	EventsHelp,
	EmployeeFieldsHelp,
	LeaveTypesHelp,
	HolidaysHelp,
	SystemNotificationsHelp,
	SurveySetupHelp,
	EmployeeGroupsHelp,
	ApproveUsersHelp,
	PromoteDemoteHelp,
	FeatureRolesHelp,
	EmployeeImportHelp,
	TimeImportHelp,
	MobileConfigurationHelp,
	RequisitionConfigurationHelp,
	BranchesHelp,
	LeaveRestrictionRuleHelp,
	UpcomingBirthdaysHelp,
	LeaveCancelHelp,
	//AddLeaveGeneralHelp,
	//AddLeaveHolidayHelp,
	//AddLeaveRestrictionHelp,
	//AddLeaveRolesHelp,
	LeaveCategoriesHelp,
	ContractsHelp,
	EmployeeDocumentCountReportHelp,
	EmployeeEmploymentListingReportHelp,
	OutstandingDataHelp,
	SkillsCompetencyDataHelp,
	EmployeesCurrentlyOnLeaveHelp,
	LeaveAutoLinkHelp,
	EmployeesActivePerDepartmentCountHelp, 
	EmployeesWithRolesHelp,
	EmployeeLeaveComingUpHelp,
	DiversityStatisticsReportHelp,
	DepartmentGrowthReportHelp,
	ManagerSubordinateStructureHelp,
	BackupManagerReportHelp,
	LeaveAvailableHelp,
	LeaveTakenReportHelp,
	EEAReportHelp, 
	LeaveTakenBreakdownByLeaveEntryHelp, 
	EmployeeDocumentsHelp,
	GeneralDocumentsHelp,
	SkillsCompetencyHelp,
	LeaveCostPerDepartmentHelp, 
	EmployeesTakingLeavePerDepartmentCountHelp,
	LeaveTakenComparisonBetweenDepartmentsHelp,
	LeaveTakenPerDayCountHelp,
	LeaveAvailableByCompanyHelp,
	SickLeaveCyclesInformationHelp,
	LeaveTrendsHelp,
	LeaveTakenByLeaveTypeHelp,
	SurveyResultsHelp,
	EmployeeAttendanceInformationHelp, 
	TimeViewHelp,
	ReportTimeLoggedHelp,
	ApproveTimeHelp,
	ApprovalStructureHelp,
	SetupTimeRulesHelp,
	AttendanceDepartmentHelp,
	AttendanceEmployeeReportHelp,
	EmployeeFieldReportHelp,
	PerformanceCycleRatingsHelp,
	Habit5ReportHelp,

	EditPerformanceManagementHelp,
	PerformanceObjectiveDetailsHelp,
	PerformanceObjectivesSummaryHelp,
	CompanyGoalsHelp,
	CycleStageHelp,
	PerformanceCyclesHelp,
	ObjectiveMeasuresHelp,
	RatingMethodsHelp,
	SetupOvertimeRulesHelp,
	AddCycleStep,
	AddCompanyObj,
	LinkCompanyObjectives,
	AddPeerGroup,
	SetLinkPerfCyclesHelp,
	SetObjectivesMeasuresHelp,
	PerformanceProgressReportHelp,
	SelfReviewRatingHelp,
	PeerReviewRatingHelp,
	ManagerReviewRatingHelp,


	AdminAddNewHolidayType,
	EmployeeCategoryAddPage,
	
	EmployeeDocumentReject,
	EmployeeGroupsAdd,
	AdminImportEmployees,
	AdminImportHoliday,
	MobileConfigurationAddImage,
	RequisitionConfigurationAddImage,
	RejectUsers,
	SurveySetupAdd,
	SurveySetupQuestionsAdd,
	SystemNotificationsAdd,
	UploadGeneralDocument,
	LeaveRestrictionRule,
	LeaveRestrictionRuleLeaveTypeEdit,
	EditDocument,

	EmployeeAddField,
	EmployeeAddLinkedLeave,
	EmployeeAddManagerDepartment,
	EmployeeConvertLeaveType,
	EmployeeEndLeaveType,
	EmployeeLeaveEntry,
	EmployeeResign,
	EmployeeUploadDocument,
	EmployeeUploadLeaveDocument,
	EmployeeUploadPhoto,
	InsertLeaveEntry,
	EmployeeAddLinkedLeaveByCategory,
	ViewPerfObjectivePlan,
	CreateCycle,
	AddObjectivePlan,
	AddRatingMethod,
	AddToObjectivePlan,
	RatingAndFeedback,
	AddPeerMembersObjePlan,

	LeaveReject,
	LeaveCancellationReject,
	OpenNotification,

	WizardCompaniesEntry,
	WizardDepartmentsEntry,
	WizardEmployeeFieldsEntry,
	WizardHolidayEntry,
	WizardLeaveTypesEntry,
	WizardFinish,
	WizardFinishBasic,

	ReportCompanyLeaveAvailableAdjustDate,
	ReportLeaveTakenSettings,
	
	WizardLeaveSetupCycle,
	WizardLeaveSetupRoles,
	WizardLeaveSetupHolidays,
	WizardLeaveSetupDescription,
	WizardHolidaySetup,
	WizardLeaveSetupEmployees,
	WizardLeaveSetupRestrictions,
	WizardLeaveSetupOverview,

	TimeLoggedReject,
	AddApprovalStructure,
	LogTime,
	LogTimeEmployee,
	EditTransactionType,
	EditProject,
	AddTimeRules,
	OvertimeRules,
	EmployeeHistoryLogHelp,
	RatingsDistributionHelp,

	EditSurveySegmentsPage,
	AnonymousSurveySetupHelp,
	CheckAttendanceReportHelp,
	AdminImportTime,
	EmployeeAddDisciplinary,
	EmployeeUploadPayrollDocument,
];


